import { render, staticRenderFns } from "./Referenzen.vue?vue&type=template&id=8587c2a8&scoped=true&"
import script from "./Referenzen.vue?vue&type=script&lang=js&"
export * from "./Referenzen.vue?vue&type=script&lang=js&"
import style0 from "./Referenzen.vue?vue&type=style&index=0&id=8587c2a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8587c2a8",
  null
  
)

export default component.exports